{
	"transactionCardHeader": "Επικυρώστε μια συναλλαγή",
	"transactionCardDescriptionBold": "Θέλετε να επικυρώσετε μια συναλλαγή για οποιοδήποτε έργο;",
	"transactionCardDescriptionRegular": "Εάν έχετε διαθέσιμο αριθμό συναλλαγής, μπορείτε να τον εισαγάγετε εδώ και να επικυρώσετε τη συναλλαγή.",
	"showTransactionButton": "Εμφάνιση συναλλαγής",
	"transactionLabel": "Αριθμός συναλλαγής",
	"errors": {
		"transactionIdRequired": "Απαιτείται αριθμός συναλλαγής.",
		"transactionNotFound": "Δεν βρέθηκε συναλλαγή.",
		"transactionIdInvalid": "Μη έγκυρος αριθμός συναλλαγής."
	}
}
